<template lang="pug">
  tr(:id="shortCode.short_code")
    td {{ shortCode.short_code }}
    td {{ shortCode.total_inbound_texts }}
    td {{ totalReferrals }}
    td {{ shortCode.callback_url }}
    td
      div
        a(
          data-cy="short-URL"
          :href="shortCode.shortened_url"
          target="_blank"
          rel="noopener noreferrer"
        )
          | {{ shortCode.shortened_url }}
      v-btn.ml-0.pl-0(
        v-if="!shortCode.shortened_url"
        data-cy="add-short-URL"
        @click="$emit('created:shortURL', shortCode.id)"
        color="primary"
        flat
        small
      )
        v-icon add
        | Create to track clicks
      v-btn.ma-0.px-0(
        v-else
        data-cy="remove-short-URL"
        color="red"
        @click="$emit('deleted:shortURL', deleteShortUrlParams)"
        flat
        small
      ) Remove
    td
      | {{ shortCode.automated_response }}
      div
        a(:href="automatedResponseUrl" target="_blank" rel="noopener noreferrer")
          | {{ automatedResponseUrl }}
    td {{ contactSource }}
    td(data-cy="short-code-campaign") {{ campaign }}
    td.actions
      .single-row
        v-tooltip(bottom)
          span Edit
          v-btn(
            icon
            slot="activator"
            @click="$emit('edit', shortCode)"
            data-cy="edit-short-code"
          )
            v-icon edit
        v-tooltip(bottom)
          span Delete
          v-btn(
            icon
            data-cy="delete-short-code"
            slot="activator"
            @click="$emit('deleted', shortCode.id)"
          )
            v-icon delete
</template>

<script>
export default {
  props: {
    // determine whether the item is selected or not
    value: Boolean,
    shortCode: {
      type: Object,
      default: {},
    },
  },
  computed: {
    deleteShortUrlParams() {
      return {
        shortCodeId: this.shortCode.id,
        shortenedUrlId: this.shortCode.shortened_url_data.id,
      };
    },
    totalReferrals() {
      if (!this.shortCode.shortened_url_data) return 0;
      return this.shortCode.shortened_url_data.total_referrals;
    },
    contactSource() {
      if (!this.shortCode.contact_source) return '';
      return this.shortCode.contact_source.name;
    },
    campaign() {
      if (!this.shortCode.campaign) return '';
      return this.shortCode.campaign.name;
    },
    automatedResponseUrl() {
      if (this.shortCode.shortened_url_data) {
        return this.shortCode.shortened_url;
      }
      return this.shortCode.callback_url;
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-btn {
    font-size: 14px;
    min-width: 0;
  }
</style>
